// extracted by mini-css-extract-plugin
export var linkhover = "index-module--linkhover--V0Dy+";
export var NearestDentist = "index-module--NearestDentist--hAWg6";
export var right = "index-module--right--vc3hR";
export var bottom = "index-module--bottom--2gKfU";
export var link = "index-module--link--Sxdpa";
export var locationlink = "index-module--locationlink--6DNOP";
export var top = "index-module--top--wPP4h";
export var learnmore = "index-module--learnmore--8aDji";
export var title = "index-module--title--RLka4";
export var sronly = "index-module--sronly--LJy2w";
export var left = "index-module--left--8jzj8";
export var image = "index-module--image--+HF-M";
export var icon = "index-module--icon--fdu+o";